module.exports = "<div class=\"csi-flex-row csi-canvas-menu-item-type\"\n    ><span>${label}</span\n></div>"